import { wujiRequest } from "../core/common/wujiRequest";
export class ProjectDnsService {
  async load(projectId) {
    const result = await wujiRequest({
      url: `/api/xy/datasource/project_dns/${projectId}`,
      method: 'get'
    });
    return result;
  }
  async loadProjectEnvList(projectId) {
    const res = await wujiRequest({
      url: `/api/xy/env?projectid=${projectId}`
    });
    return res.map(item => ({
      env: item.env,
      name: item.name
    }));
  }
  async loadCustomDnsPlugins(projectId) {
    const res = await wujiRequest({
      url: `/api/xy/datasource/dnstype?projectid=${projectId}`,
      method: 'get'
    });
    return res;
  }
  async loadFrontEndDNS(projectId, envId) {
    var _target;
    const {
      hostEnvListFrontEnd = []
    } = await this.load(projectId);
    let target = hostEnvListFrontEnd.find(item => item.id === envId);
    if (!((_target = target) !== null && _target !== void 0 && _target.host)) {
      target = hostEnvListFrontEnd.find(item => item.id === 'default');
    }
    return target !== null && target !== void 0 ? target : null;
  }
}
export default new ProjectDnsService();
//# sourceMappingURL=projectDnsService.js.map
